import { TextTab } from "../TextTab";
import { TableTab } from "../TableTab";
import { useTemplateEditorStore } from "../../../store/useTemplateEditorStore";
import { ITEM_TYPES } from "../../../types";

export const ContentTab = ({
  previewWidth,
  previewHeight,
}: {
  previewWidth: number;
  previewHeight: number;
}) => {
  const { currentItem } = useTemplateEditorStore((state) => ({
    currentItem: state.templateState.currentItem,
  }));

  return (
    <>
      <TextTab previewWidth={previewWidth} previewHeight={previewHeight} />
      {currentItem?.type === ITEM_TYPES.Table && (
        <TableTab previewWidth={previewWidth} previewHeight={previewHeight} />
      )}
    </>
  );
};
